import {
  MallOrderStatusEnums,
  MallOrderStatusNameJson,
  PaymentMethodEnums
} from "@/enums/mall";
import $store from "@/store";
import dayjs from "dayjs";
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
import { FORMAT_DATE_ORDER, FORMAT_DATE_NORMAL } from "../common/date";

/**
 *
 * @param item
 */
export const formatProductData = (item: any, immediate: boolean = false) => {
  // 格式化属性名
  const {
    _sectionWidth = "",
    _flatten = "",
    _hubDiameter = "",
    _pattern = "",
    isExpress = "false",
    _specification = ""
  } = formatAttributeData(item.attribute || item.attributeList, immediate);
  item._attrName = _specification; //`${_sectionWidth}/${_flatten}R${_hubDiameter}`;
  item._isExpress = (isExpress && JSON.parse(isExpress)) || false;
  item._pattern = _pattern;
  item._specification = _specification;
  return item;
};

/**
 * 格式化所有的属性，返回属性对象
 * @param attrStr 属性字符串
 */
export const formatAttributeData = (
  attrStr: string,
  immediate: boolean = false
) => {
  const attrs = JSON.parse(attrStr ?? "{}");
  if (Array.isArray(attrs)) {
    return Object.assign(
      {},
      ...attrs.map(item => {
        return generateAttrObject(item.attributeCode, item.attributeValues);
      })
    );
  } else {
    return Object.assign(
      {},
      ...Object.keys(attrs).map(key => {
        return generateAttrObject(key, attrs[key], immediate);
      })
    );
  }
};

// immediate = true 不用将code转name
export function generateAttrObject(
  key = "",
  value = "",
  immediate: boolean = false
) {
  let attrValueName = value;
  if (!immediate) {
    // 属性数据
    const productAttrData =
      ($store.state as any)?.MallAttributeModule?.productAttrData || {};
    const attr =
      productAttrData[key]?.find(o => o.attrValueCode === value) ?? {};
    attrValueName = attr?.attrValueName;
  }
  return { [key]: attrValueName };
}

/**
 * 订单时间格式化
 */
export const filterOrderDate = orderDateStr => {
  if (!orderDateStr) return "";
  return dayjs(orderDateStr, FORMAT_DATE_ORDER).format(FORMAT_DATE_NORMAL);
};

/**
 * 返回 123,123,123,123
 * @param arr 对象数组
 * @param field 对象的字段
 * @param symbol 拼接字符
 */
export const joinChar = (
  arr: any[],
  field: string,
  symbol?: string
): string => {
  return arr.map(o => o[field]).join(symbol ?? ",") || "";
};

// 获取属性
export const getAttributes = (attributes = []) =>
  Object.assign(
    {},
    ...attributes
      .filter(o =>
        [
          "_sectionWidth",
          "_flatten",
          "_hubDiameter",
          "_pattern",
          "isExpress",
          "_specification"
        ].includes(o.attrCode)
      )
      .map(o => ({
        [o.attrCode]: o.attrValue && o.attrValue[0].valueName
      }))
  );

// 规格名字
export const getAttrName = (attribute: any = {}) => {
  const { _flatten = "", _hubDiameter = "", _sectionWidth = "" } = attribute;
  return `${_sectionWidth}/${_flatten}R${_hubDiameter}`;
};

// 处理用户搜索关键字，匹配——规格，花纹
export const handleKeywordForSearch = (keyword: string = "") => {
  if (!keyword) return {};
  // const _sectionWidthValueArr = []; // 三位数字
  // const _flattenValueArr = []; // 两位数字
  // const _hubDiameterValueArr = []; // 两位数字
  // const _patternValueArr = []; // 花纹

  // const addValueByLength = (words: string[] = []) => {
  //   if (!words || words.length === 0) return;
  //   console.log("in: ", words);
  //   for (const word of words) {
  //     switch (word.length) {
  //       case 1:
  //         break;
  //       case 2:
  //         _flattenValueArr.push(word);
  //         _hubDiameterValueArr.push(word);
  //         break;
  //       case 3:
  //         _sectionWidthValueArr.push(word);
  //         break;
  //       default:
  //         // 长度大于3的数字
  //         addValueByLength(
  //           /([\d]{3})([\d]{2})?([\d]{2})?/gi
  //             .exec(word)
  //             .slice(1)
  //             .filter(Boolean)
  //         );
  //     }
  //   }
  // };

  // // 匹配规格
  // const addSpedByKeyword = (keyword: string) => {
  //   let res = keyword.replace(/\D/gi, " ").split(" ").filter(Boolean);
  //   addValueByLength(res);
  // };

  // // 匹配花纹
  // const addPatternByKeyword = (keyword: string) => {
  //   _patternValueArr.push(...keyword.split(" ").filter(Boolean));
  // };

  // addSpedByKeyword(keyword);
  // addPatternByKeyword(keyword);

  return {
    _specification: keyword,
    _specificationDigital: keyword,
    _pattern: keyword,
    _shotParentSearch: keyword
  };
};

/**
 * 获取线上线下订单
 * 返回 boolean
 * false - 线下支付
 * true  - 线上支付
 * @param orderDetail
 */
export const getOnlineOrOfflinePayment = (orderDetail: any = {}): boolean => {
  if (orderDetail.payMentType) {
    return orderDetail.payMentType !== PaymentMethodEnums.OFFLINE;
  }
  let payInfo;
  if ((payInfo = orderDetail?.payInfos?.[0])) {
    return payInfo.payMentType !== PaymentMethodEnums.OFFLINE;
  }
  return false;
};

// 能否取消订单
export const canCancelOrder = function (orderDetail: any) {
  return (
    // 线上支付，待支付状态，可以取消
    ([MallOrderStatusEnums.WAIT_PAY].includes(orderDetail.orderStatus) &&
      getOnlineOrOfflinePayment(orderDetail)) ||
    // 线下支付，待发货状态，可以取消
    ([MallOrderStatusEnums.WAIT_SEND].includes(orderDetail.orderStatus) &&
      !getOnlineOrOfflinePayment(orderDetail))
  );
};

// 显示取消按钮
export const showCancelOrder = function (orderDetail: any) {
  return (
    canCancelOrder(orderDetail) &&
    !(
      orderDetail.orderRefundOuts?.length || orderDetail.orderReturnOuts?.length
    )
  );
};

// 订单状态显示
export const getOrderStatusText = (orderDetail: any) => {
  if (
    canCancelOrder(orderDetail) &&
    (orderDetail.orderRefundOuts?.length || orderDetail.orderReturnOuts?.length)
  ) {
    return "取消中";
  }
  return MallOrderStatusNameJson[orderDetail.orderStatus];
};

export const initFilterSelect = data => {
  return data.map(item => {
    // 升序排序
    item.attrValueList.sort((a, b) => {
      // NA放在最后
      if (a.attrValueName === "NA") {
        return 1;
      }
      if (b.attrValueName === "NA") {
        return -1;
      }
      return a.attrValueName - b.attrValueName;
    });
    // 未选中
    item.attrValueList =
      item?.attrValueList?.map((o: any) => {
        o._select = false;
        return o;
      }) || [];
    return item;
  });
};
